import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../plugins/custom_css/404.css";

export const NotFound = () => {
  useEffect(() => {
    document.title = "Page Not Found - Smart Scholars 360";
    const pupils = document.querySelectorAll(".eye__pupil");

    const handleMouseMove = (e) => {
      pupils.forEach((pupil) => {
        const eye = pupil.parentElement.getBoundingClientRect();
        const eyeCenterX = eye.left + eye.width / 2;
        const eyeCenterY = eye.top + eye.height / 2;
        const angle = Math.atan2(
          e.clientY - eyeCenterY,
          e.clientX - eyeCenterX
        );
        const maxDistance = 10;
        const pupilX = Math.cos(angle) * maxDistance;
        const pupilY = Math.sin(angle) * maxDistance;

        pupil.style.transform = `translate(${pupilX}px, ${pupilY}px)`;
      });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <main className="error-page">
      <div className="container cont">
        <div className="eyes">
          <div className="eye">
            <div className="eye__pupil eye__pupil--left"></div>
          </div>
          <div className="eye">
            <div className="eye__pupil eye__pupil--right"></div>
          </div>
        </div>

        <div className="error-page__heading">
          <h1 className="error-page__heading-title">Looks like you're lost</h1>
          <p className="error-page__heading-desciption">404 error</p>
        </div>

        <Link
          className="error-page__button"
          to="/"
          aria-label="back to home"
          title="back to home"
        >
          back to home
        </Link>
      </div>
    </main>
  );
};
